import { Entity, Field } from 'typegraph';

import { ID } from 'common/entities/IEntity';
import Tag from './Tag';
import { Credit } from './Credit';

class ProductTyped {
	@Field()
	public  baseType:String;
}


@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: ID;

	@Field()
	public externalId?: string;

	@Field()
	public name: string;

	@Field()
	public displayName: string;

	@Field()
	public subTitle: string;

	@Field()
	public iconURL?: string;

	@Field()
	public smallIconURL?: string;

	@Field({ entity: ProductTyped })
	public type: ProductTyped;

	@Field({entity: Tag})
	public tags?: Tag[];

	@Field({entity: Credit})
	public credits?: Credit[];

	@Field()
	public customField1?: string;

	@Field()
	public customField2?: string;

	@Field()
	public customField3?: string;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/Product.ts